import { useQuery } from '@apollo/client';
import React from 'react';

import { getAuthProvider } from '@/api/app/get_auth_provider';
import HiddenForm, { HiddenFormProps } from '@/components/shared/mantine/HiddenForm';
import { wentWrong } from '@/helpers/notification_helpers';

type ProceedNextStepProps = {
  email: string;
  token: string;
  onError(): void;
  onComplete(): void;
  sourceUri?: string;
  additionalFields?: HiddenFormProps['fields'];
};

const ProceedNextStep: React.FC<ProceedNextStepProps> = ({
  email,
  token,
  onError,
  onComplete,
  sourceUri,
  additionalFields = {},
}) => {
  const { data, error } = useQuery(getAuthProvider, { variables: { email, sourceUri } });

  if (error) {
    onError();
    wentWrong(error?.message ?? '');
    return <></>;
  }

  // waiting for data
  if (!data?.data?.providerUrl) {
    return <></>;
  }

  const fields = {
    login_hint: email,
    authenticity_token: token,
    ...additionalFields,
  };

  return (
    <HiddenForm
      method="post"
      action={data.data.providerUrl}
      fields={fields}
      onComplete={onComplete}
    />
  );
};

export default ProceedNextStep;
